/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';

export const FETCH = Symbol('fetch action');

const middleware = ({ dispatch }) => (next) => (action) => {
  const fetchConfig = action[FETCH];

  if (fetchConfig === undefined) {
    return next(action);
  }

  delete action[FETCH]; // eslint-disable-line no-param-reassign

  dispatch({ ...action, status: 'start' });

  const { method = 'GET', data, success, fail, requireBlobData, ...restConfig } = fetchConfig;

  const config = {
    method,
    data: data || {},
    ...restConfig,
  };

  if (requireBlobData) {
    config.responseType = 'blob';
  }

  return axios.request(config)
    .then((response) => {
      success && success(response.data);
      return next({
        ...action,
        data: response,
        status: 'done',
      });
    })
    .catch((error) => {
      fail && fail(error);
      return next({
        ...action,
        error: error.response,
        status: 'error',
      });
    });
};

export default middleware;
